import { createStore } from "vuex";

// Import store modules.
import TeamsModule from "./modules/teams";
import TeamActionsModule from "./modules/team_actions";
import PosModule from "./modules/pos";

const store = createStore({
  modules: {
    pos: PosModule,
    teams: TeamsModule,
    team_actions: TeamActionsModule
  },
  plugins: []
});

export default store;
